export type ShotArcKind='driver'|'wood'|'hybrid'|'iron'|'wedge'|'putter'|'unknown'

export function classifyShotArc(club:string):ShotArcKind {
  const value=club.trim().toLowerCase().replace(/\s+/g,'')
  if(value.includes('putter'))return 'putter'
  if(value.includes('driver'))return 'driver'
  if(value.includes('hybrid')||/^\d+h$/.test(value))return 'hybrid'
  if(value.includes('wood')||/^\d+w$/.test(value))return 'wood'
  if(value.includes('wedge')||/^(pw|gw|sw|lw)$/.test(value))return 'wedge'
  if(value.includes('iron')||/^\d+i?$/.test(value))return 'iron'
  return 'unknown'
}

export function arcHeightPixels(club:string,projectedDistance:number){
  const kind=classifyShotArc(club)
  if(kind==='putter')return Math.min(4,projectedDistance*.025)
  const multiplier={driver:.62,wood:.82,hybrid:.95,iron:1.22,wedge:1.4,unknown:1}[kind]
  return Math.min(132,Math.max(28,32+projectedDistance*.18)*multiplier)
}
